import {
  API_ERROR,
  GOOGLE_LOGIN_FAIL,
  GOOGLE_LOGIN_INIT,
  GOOGLE_LOGIN_SUCCESS,
  LOGIN_SUCCESS,
  LOGIN_USER,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LOGOUT_USER:
      state = { ...state };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;
    case GOOGLE_LOGIN_INIT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GOOGLE_LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case GOOGLE_LOGIN_FAIL:
      state = {
        ...state,
        loading: false,
      };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
